var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResources(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 5.95703C8.25 5.19764 8.86561 4.58203 9.625 4.58203H17.875C18.6344 4.58203 19.25 5.19764 19.25 5.95703C19.25 6.71642 18.6344 7.33203 17.875 7.33203H9.625C8.86561 7.33203 8.25 6.71642 8.25 5.95703ZM8.25 10.5404C8.25 9.78097 8.86561 9.16536 9.625 9.16536H17.875C18.6344 9.16536 19.25 9.78097 19.25 10.5404C19.25 11.2998 18.6344 11.9154 17.875 11.9154H9.625C8.86561 11.9154 8.25 11.2998 8.25 10.5404ZM9.625 13.7487C8.86561 13.7487 8.25 14.3643 8.25 15.1237C8.25 15.8831 8.86561 16.4987 9.625 16.4987H17.875C18.6344 16.4987 19.25 15.8831 19.25 15.1237C19.25 14.3643 18.6344 13.7487 17.875 13.7487H9.625Z",
    fill: "#B0B7C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.04175 7.33203C5.80114 7.33203 6.41675 6.71642 6.41675 5.95703C6.41675 5.19764 5.80114 4.58203 5.04175 4.58203C4.28236 4.58203 3.66675 5.19764 3.66675 5.95703C3.66675 6.71642 4.28236 7.33203 5.04175 7.33203ZM5.04175 11.9154C5.80114 11.9154 6.41675 11.2998 6.41675 10.5404C6.41675 9.78097 5.80114 9.16536 5.04175 9.16536C4.28236 9.16536 3.66675 9.78097 3.66675 10.5404C3.66675 11.2998 4.28236 11.9154 5.04175 11.9154ZM6.41675 15.1237C6.41675 15.8831 5.80114 16.4987 5.04175 16.4987C4.28236 16.4987 3.66675 15.8831 3.66675 15.1237C3.66675 14.3643 4.28236 13.7487 5.04175 13.7487C5.80114 13.7487 6.41675 14.3643 6.41675 15.1237Z",
    fill: "#B0B7C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResources);
export default __webpack_public_path__ + "static/media/resources.7c1a21849fcda26c67d4fe72a3f9b375.svg";
export { ForwardRef as ReactComponent };